interface Map3DView {
  getPitch?: () => number
  getRotation?: () => number
  setPitch?: (pitch: number, immediately?: boolean, duration?: number) => void
  setRotation?: (rotation: number, immediately?: boolean, duration?: number) => void
}

interface Map3DOwners {
  pitch: number
  rotation: number
  owners: Map<string, symbol>
}

const mapOwners = new WeakMap<Map3DView, Map3DOwners>()

/** A stale release cannot close a newer owner or restore the camera over another layer. */
export function acquireMap3DOwner (map: Map3DView, ownerKey: string, initialPitch?: number): () => void {
  let state = mapOwners.get(map)
  if (!state) {
    state = { pitch: Number(map.getPitch?.()) || 0, rotation: Number(map.getRotation?.()) || 0, owners: new Map() }
    mapOwners.set(map, state)
    if (initialPitch !== undefined && Number.isFinite(initialPitch)) {
      map.setPitch?.(initialPitch, true)
    }
  }
  const token = Symbol(ownerKey)
  state.owners.set(ownerKey, token)
  return () => {
    const current = mapOwners.get(map)
    if (!current || current.owners.get(ownerKey) !== token) {
      return
    }
    current.owners.delete(ownerKey)
    if (current.owners.size > 0) {
      return
    }
    mapOwners.delete(map)
    map.setPitch?.(current.pitch, false, 300)
    map.setRotation?.(current.rotation, false, 300)
  }
}

export function hasMap3DOwner (map: Map3DView): boolean {
  return Boolean(mapOwners.get(map)?.owners.size)
}
